import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { BadgeTypes } from '../../../badge';
import Badge from '../../../badge/badge';

const BadgeWrapper = ({
  id, label, hasError, onClick,
}) => {
  const clickCallback = useCallback(() => onClick(id), [id, onClick]);

  return (
    <Badge
      key={id}
      showRemove
      label={label}
      showDot={false}
      onClick={clickCallback}
      type={hasError ? BadgeTypes.ERROR : BadgeTypes.PRIMARY}
    />
  );
};

BadgeWrapper.defaultProps = {
  id: {},
  label: '',
  hasError: false,
  onClick: () => {},
};

BadgeWrapper.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  hasError: PropTypes.bool,
  onClick: PropTypes.func,
};

export default memo(BadgeWrapper);
